import images from './landingImages.json'

const imageSources = new Map(images.map((image) => [image.src, image]))

// Full-width photos use the original panoramic artwork; account for cover cropping on phones.
export const heroImageSizes = '(max-width: 767px) 1400px, (max-width: 1345px) 1345px, 100vw'

export const getLandingImageProps = (src, sizes) => {
  const image = imageSources.get(src)
  if (!image) return {}
  const basename = src.replace(/^\/images\//, '').replace(/\.[^.]+$/, '')
  return {
    srcSet: image.widths.map((width) => `/images/optimized/${basename}-${width}.webp ${width}w`).join(', '),
    sizes,
  }
}
